<script>
import { EpisodePageElementMixin } from "%/dynamic-component-editor/standard-pages/episode-page/episode-page-element-mixin";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";
import { dateFromUnixTimestamp, formatDateString } from "@bloglovin/vue-framework";

export default {
  name: "EpisodeReleaseDate",
  elementPanelSettings: {
    displayName: "Release Date",
    displayIcon: "lets-icons:date-fill",
    elementGroup: "episode",
    elementType: "element",
  },
  extends: TextElement,
  mixins: [EpisodePageElementMixin],
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    value() {
      const timeStamp = this.entity.releasedAt;
      const date = dateFromUnixTimestamp(timeStamp);
      return formatDateString(date, {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
  },
};
</script>
